import { ref } from 'vue'
import { usePageCache } from '@/hooks/usePageCache'

export function useSection() {
  const { getCache, updateCache } = usePageCache()
  const table = getCache()?.table || {}
  // 已选择的选项
  const sectionList = ref<Recordable[]>(table.sectionList || [])
  // 选中项发生改变
  function selectionChange(data: any) {
    console.log(data, '选中项发生改变')
    sectionList.value = JSON.parse(JSON.stringify(data))
    // console.log(sectionList.value, 'sectionList')
    updateCache({ table: { sectionList: data } })
  }
  return {
    sectionList,
    selectionChange
  }
}
